import { j as c } from "../../../jsx-runtime-B6kdoens.js";
import { a as m } from "../../../index-CROKJrb5.js";
import { c as p, f } from "../../../create-component-CBAeEoQ6.js";
const l = p(
  "FooterSocialRow",
  f(
    ({ as: o, children: r, className: t, ...a }, e) => {
      const s = o || "div";
      return /* @__PURE__ */ c.jsx(
        s,
        {
          ref: e,
          className: m("cur-flex cur-flex-wrap cur-gap-2", t),
          ...a,
          children: r
        }
      );
    }
  )
);
export {
  l as FooterSocialRow
};
//# sourceMappingURL=index.js.map
